import { render } from "./currentDetails.vue?vue&type=template&id=0d924f6c&scoped=true"
import script from "./currentDetails.vue?vue&type=script&lang=js"
export * from "./currentDetails.vue?vue&type=script&lang=js"

import "./currentDetails.vue?vue&type=style&index=0&id=0d924f6c&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d924f6c"]])

export default __exports__